import PolylineUtils from 'js/services/util/polyline_utils'
import TopologyCalculationsService from 'js/services/topology-calculations.js'

export default {
  data() {
    return {
      routesToShow: [],
      routeShapes: {}
    }
  },

  watch: {
    routesToShow() {
      this.generateRouteShapes()
    }
  },

  methods: {
    /*
     * Genera los shapes de las rutas
     */
    generateRouteShapes() {
      this.routeShapes = {}

      this.routesToShow.forEach((currentRoute, index, array) => {
        const decodedPoints = PolylineUtils.decodePolyline(currentRoute.encoded_shape)
        const shape = _.map(decodedPoints, decodedPoint => ({
          lat: decodedPoint[0],
          lng: decodedPoint[1]
        }))
        const geojson = TopologyCalculationsService.getGeojson(shape)

        if (geojson) {
          this.routeShapes[currentRoute.id] = geojson
        } else {
          array.splice(index, 1)
        }
      })
    },

    /*
     * Devuelve true si contiene la shape de la ruta
     */
    hasRouteShape(route) {
      return this.routeShapes.has(route.id)
    },

    /*
     * Devuelve la forma que debería tener una ruta
     */
    routeShape(route) {
      return this.routeShapes[route.id]
    },

    /*
     * Devuelve el estilo que debería tener una ruta
     */
    routeStyle(route) {
      return () => ({
        color: route.subline_color || '#000000',
        opacity: 0.7,
        weight: 3
      })
    }
  }
}
